export enum MessageUiComponentResultOutcome {
  Success = "success",
  Error = "error",
  Denied = "denied",
}
